if (!customElements.get('notification-emitter')) {

  class NotificationEmitter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Listen for Shopify's cart:add event
      document.addEventListener('cart:add', (event) => {
        this.handleCartAdd(event.detail);
      });

      // Listen for custom cart addition events
      document.addEventListener('product:added-to-cart', (event) => {
        this.handleCartAdd(event.detail);
      });

      // Intercept Shopify AJAX cart add requests
      this.interceptCartRequests();
    }

    handleCartAdd(detail) {
      // Extract product information
      const productTitle = detail?.product?.title || 
                          detail?.product_title || 
                          detail?.title || 
                          'Product';
      
      const variantTitle = detail?.product?.variant_title || 
                          detail?.variant_title || 
                          detail?.variant?.title || 
                          '';
      
      const quantity = detail?.quantity || 1;

      // Construct message
      let message = 'wurde zum Warenkorb hinzugefügt.';
      if (quantity > 1) {
        message = `(${quantity}) wurden zum Warenkorb hinzugefügt.`;
      }

      // Emit notification
      document.dispatchEvent(new CustomEvent('notification', {
        detail: {
          message: message,
          type: 'success',
          // product: variantTitle || productTitle,
          product: productTitle,
          duration: 6000
        }
      }));
    }

    interceptCartRequests() {
      // Store original fetch
      const originalFetch = window.fetch;
      
      // Override fetch to intercept cart add requests
      window.fetch = async (...args) => {
        const [resource, config] = args;
        
        // Check if it's a cart add request
        if (resource && (
          resource.includes('/cart/add') || 
          resource.includes('/cart/add.js')
        )) {
          try {
            const response = await originalFetch(...args);
            
            // Clone response so we can read it
            const clonedResponse = response.clone();
            
            if (response.ok) {
              const data = await clonedResponse.json();
              
              // Emit notification for successful cart add
              this.handleCartAdd({
                product_title: data.product_title,
                variant_title: data.variant_title,
                title: data.title,
                quantity: data.quantity || 1
              });
            }
            
            return response;
          } catch (error) {
            console.error('Error intercepting cart add:', error);
            return originalFetch(...args);
          }
        }
        
        return originalFetch(...args);
      };
    }

    disconnectedCallback() {
      // Note: fetch override persists after disconnection
      // Consider restoring original fetch if needed
    }

  }

  customElements.define('notification-emitter', NotificationEmitter);

}